import React, { useState } from 'react';
import classNames from 'classnames';
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import { Button, Icons } from '../base/BootstrapComponents/BootstrapComponents';
import EditPassword from './EditPassword';
import Dropdown from '../base/Dropdown/Dropdown';
import { getClientPersonalData } from '../../modules/Authorized/reducer';
import { userShortFIOFormatter } from '../../utils/formatters';

export default function MiniProfile({ onHide = () => {} }) {
  const [showProfile, setShowProfile] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const navigate = useNavigate();

  const profile = useSelector(getClientPersonalData);
  const defaultAvatar = `${process.env.PUBLIC_URL}/img/default-avatar.svg`;

  return (
    <div className="mini-profile-dropdown">
      <Dropdown onToggleOpen={state => setShowDropdown(state)}>
        <Dropdown.Toggle className={classNames('mini-profile', { isOpen: showDropdown })}>
          <div className="mini-profile-text">
            <div className="mp-name">{userShortFIOFormatter(profile)}</div>
            {/* <div className="mp-profession">{userProfile}</div> */}
          </div>
          <div className="mini-profile-image">
            <img
              className="mini-profile-avatar"
              src={defaultAvatar}
              alt="A"
              onError={e => {
                e.target.src = defaultAvatar;
              }}
            />
          </div>
          <div className="mini-profile-arrow">
            <Icons customIcon className="select-arrow" width={12} height={8} icon="arrow-down" />
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu className="mini-profile-menu">
          {/* setShowProfile(!showProfile) */}
          <Button className="mini-profile-menu-button" onClick={() => navigate('/notification')}>
            <Icons customIcon className="menu-item-icon" icon="notification" /> Уведомления
          </Button>
          <Button className="mini-profile-menu-button" onClick={() => navigate('/logout')}>
            <Icons customIcon className="menu-item-icon" icon="exit" /> Выход
          </Button>
        </Dropdown.Menu>
      </Dropdown>

      {showProfile ? <EditPassword onHide={() => setShowProfile(false)} /> : null}
    </div>
  );
}
